import React, {
  useEffect, useState, useContext,
} from 'react';
import { useParams } from 'react-router-dom-v5-compat';
import styled from 'styled-components';
import PreviousMeetingHeader from './components/HeaderBar';
import PreviousMeetingNotesView from './components/NotesView';
import { AuthContext, UserDataContext } from '../../../App';
import dbListenToMeetingData from '../../../database/Meetings/firebaseMeetingAPI';
import {
  TaskItems, MeetingData, MeetingSection,
  TaskTab, AuthState, User, PrivateNoteData,
} from '../../types/types';
import TabsMenu from '../../../pages/meeting/tab/TabsMenu';
import { pendingMeetingData } from '../../../database/utils/templateMeetingData';
import { dbListenToTasksForMeeting } from '../../../database/firebaseTasksAPI';
import { darkBlue1 } from '../../colours';
import sendPreviousMeetingWindowMessage from '../../../utils/previousMeetingInjection';
import PreviousMeetingDropDown from './components/DropDown';
import TextEditorBottomOverlay from './components/BottomOverlay';
import PreviousMeetingDataContext from './context/PreviousMeetingDataContext';
import { MEETING_SECTION, TASK_TAB } from '../../../utils/enums';
import { pendingTaskItems } from '../../../utils/tasks/tasksUtils';
import MeetingDataContext from '../../../pages/meeting/context/MeetingDataContext';
import RelMeetUtils from '../MeetingDetailsHeader/RelevantMeetingComponent/RelevantMeetingsUtils';

const Container = styled.div`
  width: 460px;
  height: calc(100vh);

  border-radius: 15px 15px 0 0;
  overflow: hidden;
`;

const HorizontalLine = styled.hr`
  margin: 0;
  border: 1px solid ${darkBlue1};
`;

const PreviousMeetingNotes = () => {
  const params = useParams();
  const authState = useContext<AuthState>(AuthContext);
  const userData = useContext<User>(UserDataContext);

  const previousMeetingId: string = params?.previousMeetingId ?? '';
  const currentMeetingId: string = params?.meetingId ?? '';

  const [previousMeetingData, setPreviousMeetingData] = useState<MeetingData>(pendingMeetingData);
  const activePrivateNoteId = '';

  const [meetingTab, setMeetingTab] = useState<MeetingSection>(MEETING_SECTION.SHARED_NOTES);
  const [meetingTasks, setMeetingTasks] = useState<TaskItems>(pendingTaskItems);
  const [taskTab, setTaskTab] = useState<TaskTab>(TASK_TAB.TODO);

  /* eslint-disable-next-line no-unused-vars */
  const [isCreateTaskModalOpen, setCreateTaskModalOpen] = useState<boolean>(false);
  // eslint-disable-next-line no-unused-vars
  const [privateNotes, setPrivateNotes] = useState<PrivateNoteData[]>([]);

  useEffect(() => {
    if (previousMeetingData.version >= 4
      && userData.settings.defaultUserTab === MEETING_SECTION.AGENDA) {
      return setMeetingTab(MEETING_SECTION.SHARED_NOTES);
    }

    return setMeetingTab(userData.settings.defaultUserTab);
  }, [previousMeetingData.version, userData.settings.defaultUserTab]);

  useEffect(() => {
    if (userData.resolvedState !== 'resolved') return () => { };
    if (previousMeetingId) {
      return dbListenToTasksForMeeting(
        previousMeetingId, authState.email, setMeetingTasks,
      );
    }

    return () => { };
  }, [previousMeetingId, userData.resolvedState]);

  useEffect(() => {
    if (userData.resolvedState !== 'resolved') return () => { };
    if (previousMeetingId) {
      return dbListenToMeetingData(
        previousMeetingId,
        authState.userId,
        setPreviousMeetingData,
        () => { },
      );
    }

    return () => { };
  }, [previousMeetingId, userData.resolvedState]);

  const handleCloseButtonClick = () => {
    sendPreviousMeetingWindowMessage({ meetingId: '', previousMeetingId: '' });
  };

  if (previousMeetingId === '') {
    return (
      <>No previous meeting</>
    );
  }

  const onClickSelectPrivateNote = (chatId: string) => console.log(chatId);

  return (
    <PreviousMeetingDataContext.Provider value={previousMeetingData}>
      <MeetingDataContext.Provider value={previousMeetingData}>
        <Container>
          <PreviousMeetingHeader
            handleClick={handleCloseButtonClick}
          />
          <HorizontalLine />
          <TabsMenu
            meetingData={previousMeetingData}
            meetingTab={meetingTab}
            setMeetingTab={setMeetingTab}
            unviewedTasks={0}
            privateNotes={privateNotes}
            onClickSelectPrivateNote={onClickSelectPrivateNote}
            setPrivateNotes={setPrivateNotes}
            meetingDataVersion={previousMeetingData.version}
            activePrivateNoteId={activePrivateNoteId}
            // TODO: Add relevant meetings for also previous meetings
            relevantMeetings={RelMeetUtils.resolvedEmptyData}
            clickRelevantMeeting={console.log}
          />
          <HorizontalLine />
          <PreviousMeetingNotesView
            taskTab={taskTab}
            setTaskTab={setTaskTab}
            meetingId={previousMeetingId}
            meetingTab={meetingTab}
            meetingTasks={meetingTasks}
            setCreateTaskModalOpen={setCreateTaskModalOpen}
          />
          <TextEditorBottomOverlay />
          <PreviousMeetingDropDown
            meetingId={currentMeetingId}
            previousMeetingId={previousMeetingId}
          />
        </Container>
      </MeetingDataContext.Provider>
    </PreviousMeetingDataContext.Provider>
  );
};

export default PreviousMeetingNotes;
